import { useBrand } from "@edreamsodigeo/frontend-core";

import { SITE_KEYS_V3 } from "./config/siteKeys";
import { useRecaptchaStyleHandler } from "./useRecaptchaStyleHandler";

interface UseRecaptchaV3 {
  loadRecaptchaScript: () => void;
  generateRecaptchaToken: (action: string) => Promise<string>;
}

interface GetWindowGrecaptchaResponse {
  ready: (callback: () => void) => void;
  execute: (sitekey: string, options: { action: string }) => Promise<string>;
}

export const useRecaptchaV3 = (): UseRecaptchaV3 => {
  const brand = useBrand();
  const recaptchaSitekey = SITE_KEYS_V3[brand];
  const loadRecaptchaStyleHandler = useRecaptchaStyleHandler();
  const getWindowGrecaptcha = (): GetWindowGrecaptchaResponse =>
    window["grecaptcha"];

  const recaptchaReady = (): Promise<void> =>
    new Promise((resolve) => {
      getWindowGrecaptcha().ready(resolve);
    });

  const loadRecaptchaScript = (): void => {
    const recaptchaId = "recaptcha-key";
    const url = `https://www.google.com/recaptcha/api.js?render=${recaptchaSitekey}&trustedtypes=true`;

    const existingRecaptchScript = document.getElementById(recaptchaId);

    if (!existingRecaptchScript) {
      const recaptchaScript = document.createElement("script");
      recaptchaScript.type = "text/javascript";
      recaptchaScript.src = url;
      recaptchaScript.id = recaptchaId;
      recaptchaScript.async = true;

      document.body.appendChild(recaptchaScript);
      loadRecaptchaStyleHandler();
    }
  };

  const generateRecaptchaToken = (action: string): Promise<string> =>
    new Promise((resolve, reject) => {
      recaptchaReady().then(() => {
        getWindowGrecaptcha()
          .execute(recaptchaSitekey, { action })
          .then((token) => {
            if (token) resolve(token);
            else reject();
          });
      });
    });

  return {
    loadRecaptchaScript,
    generateRecaptchaToken,
  };
};
